import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TIconName } from '@monorepo/types';

import * as _ from 'lodash';

@Component({
  selector: 'zf-button',
  templateUrl: 'zf-button.html',
  styleUrls: ['zf-button.scss'],
})
export class ZFButton implements OnChanges {
  @Input()
  buttonType!: TButtonType;
  @Input()
  outline!: boolean;
  @Input()
  href!: string;
  @Input()
  state!: TButtonState;
  @Input()
  iconProperties!: IconProperties;
  @Input() buttonClasses: string[] = [];

  @Input()
  buttonWidth!: number;
  @Input()
  buttonHeight!: number;
  @Input() colorFill;

  // @Input() outlineType;
  // @Input() colorOutline;
  // @Input() borderWidth;
  // @Input() borderRadius;

  // @Input() textFamily;
  // @Input() textColor;
  // @Input() textCase;
  // @Input() textSize;
  // @Input() textWeight;
  // @Input() lineHeight;
  // @Input() padding;
  // @Input() overflow;

  @Output() clickEvent = new EventEmitter();

  private componentClassPrefix = 'zf-btn';
  private seperator = '-';

  buttonClass: string[] = [];
  private btnType;
  btnState!: TButtonState;
  private onclick;
  private txtColor;

  constructor() {}

  ngOnChanges() {
    this.setButtonProperties();
  }

  setButtonProperties() {
    this.buttonClass = [];
    this.btnType = this.buttonType ? this.buttonType : 'primary';

    if (this.iconProperties) {
      this.btnType = this.btnType + ButtonSubType.linkIcon;
    } else if (this.href) {
      this.btnType = this.btnType + ButtonSubType.link;
    } else if (this.outline) {
      this.btnType = this.btnType + ButtonSubType.outline;
    }

    this.btnState = this.state ? this.state : 'default';

    this.buttonClass.push(
      this.componentClassPrefix + this.seperator + this.btnType + this.seperator + this.btnState,
      ...this.buttonClasses,
    );
    this.buttonClass = _.compact(this.buttonClass);
  }

  handleClick() {
    this.clickEvent.emit();
  }
}

export type TButtonType = 'primary' | 'secondary';

export enum ButtonSubType {
  linkIcon = '-link-icon',
  link = '-link',
  outline = '-outline',
}

type TButtonState = 'default' | 'active' | 'disabled';

export interface IconProperties {
  iconName: TIconName;
  iconClasses?: string[];
  fill?: string;
  strokeWidth?: number;
  inactiveClass?: string;
  isActive?: string;
}
